import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

import {
    Location,
    LocationStrategy,
    PathLocationStrategy
} from '@angular/common';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from 'src/app/services/shared/shared.service';
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    focus: boolean = false;
    public listTitles: any[];
    public location: Location;
    sidenavOpen = true;
    public login_user_firstname:any;
    public login_user_lastname:any;
    public login_user_email:any;
    activeTab = '';
    dashboardType: string | null = null;
    constructor(
        location: Location,
        private element: ElementRef,
        private loginService: AuthenticationService,
        private sharedService: SharedService,
        private router: Router
    ) {
        this.login_user_firstname= this.loginService.user.first_name;
        this.login_user_lastname= this.loginService.user.last_name;
        this.login_user_email= this.loginService.user.email;

        this.location = location;
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                // Show loading indicator

            }
            if (event instanceof NavigationEnd) {
                // Hide loading indicator

                if (window.innerWidth < 1200) {
                    document.body.classList.remove('g-sidenav-pinned');
                    document.body.classList.add('g-sidenav-hidden');
                    this.sidenavOpen = false;
                }
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator

                // Present error to user

            }
        });

    }

    ngOnInit() {

        this.listTitles = ROUTES.filter(listTitle => listTitle);
        const currentRoute = this.router.url.split('?')[0];

        this.sharedService.activeTab$.subscribe((tabName) => {
            this.activeTab = tabName; // Update the active tab name
          });

          this.sharedService.dashboardType$.subscribe((type) => {
            this.dashboardType = type;
          });

          if (currentRoute.includes('dashboard')) {
            const storedTab = localStorage.getItem('activeTab') || 'Dashboard';
            this.sharedService.setActiveTab(storedTab);

            const storedDashboardType = localStorage.getItem('dashboardType') || 'Order';
            this.sharedService.setDashboardType(storedDashboardType);
          }
    }
    getTitle() {
        let titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }

        for (let item = 0; item < this.listTitles.length; item++) {
            if (this.listTitles[item].path === titlee) {
                return this.listTitles[item].title;
            }
        }
        return 'Dashboard';
    }

    openSearch() {
        document.body.classList.add('g-navbar-search-showing');
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-showing');
            document.body.classList.add('g-navbar-search-show');
        }, 150);
        setTimeout(function () {
            document.body.classList.add('g-navbar-search-shown');
        }, 300);
    }
    closeSearch() {
        document.body.classList.remove('g-navbar-search-shown');
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-show');
            document.body.classList.add('g-navbar-search-hiding');
        }, 150);
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-hiding');
            document.body.classList.add('g-navbar-search-hidden');
        }, 300);
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-hidden');
        }, 500);
    }
    openSidebar() {
        if (document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.remove('g-sidenav-pinned');
            document.body.classList.add('g-sidenav-hidden');
            this.sidenavOpen = false;
        } else {
            document.body.classList.add('g-sidenav-pinned');
            document.body.classList.remove('g-sidenav-hidden');
            this.sidenavOpen = true;
        }
    }
    toggleSidenav() {
        if (document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.remove('g-sidenav-pinned');
            document.body.classList.add('g-sidenav-hidden');
            this.sidenavOpen = false;
        } else {
            document.body.classList.add('g-sidenav-pinned');
            document.body.classList.remove('g-sidenav-hidden');
            this.sidenavOpen = true;
        }
    }
    logout(){
        this.loginService.logout();
    }
}
